import React from "react";
import StaticPageLayout from "./StaticPageLayout";

const EMAIL = "contact@arcanechronicles.com";
const UPDATED = "2026-04-23";

export default function TermsOfService() {
  return (
    <StaticPageLayout titleIt="Termini di Servizio" titleEn="Terms of Service">
      {(isIt) => (
        <>
          <p className="text-xs text-[#94a3b8]">{isIt ? "Ultimo aggiornamento" : "Last updated"}: {UPDATED}</p>
          {isIt ? (
            <>
              <h2 className="font-heading text-xl text-[#cfb53b] mt-4">1. Accettazione</h2>
              <p>Utilizzando Arcane Chronicles (di seguito "il Servizio") accetti integralmente questi Termini di Servizio. Se non sei d'accordo, interrompi l'uso del Servizio.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">2. Descrizione</h2>
              <p>Arcane Chronicles è un gioco di ruolo narrativo con contenuti generati da intelligenza artificiale (testo, immagini), battaglie a carte, collezionismo di carte e sistema di scambi tra giocatori. Il servizio è fornito "così com'è".</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">3. Account</h2>
              <ul className="list-disc pl-5">
                <li>Devi avere almeno 13 anni (16 se in UE) per registrare un account.</li>
                <li>Sei responsabile della sicurezza delle tue credenziali.</li>
                <li>Non puoi trasferire, vendere o condividere il tuo account.</li>
                <li>Puoi richiedere la cancellazione in qualsiasi momento scrivendo a <a className="text-[#cfb53b]" href={`mailto:${EMAIL}`}>{EMAIL}</a>.</li>
              </ul>

              <h2 className="font-heading text-xl text-[#cfb53b]">4. Contenuti generati dall'IA</h2>
              <p>I contenuti narrativi e visivi generati dall'IA sono creati dinamicamente in base alle tue scelte. Possono contenere errori, incoerenze o risultati inaspettati. Non garantiamo accuratezza storica, scientifica o morale. Il Servizio non è responsabile per il contenuto generato.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">5. Comportamenti vietati</h2>
              <p>È vietato:</p>
              <ul className="list-disc pl-5">
                <li>Aggirare i limiti di generazione IA o i meccanismi anti-abuso.</li>
                <li>Usare bot, script o mezzi automatizzati non autorizzati.</li>
                <li>Tentare di compromettere la sicurezza del sistema.</li>
                <li>Inserire contenuti illegali, offensivi, discriminatori nei prompt o nei nomi.</li>
                <li>Utilizzare il sistema di scambi per frodare altri giocatori.</li>
                <li>Vendere carte, oro o account in cambio di valuta reale all'esterno del Servizio.</li>
              </ul>

              <h2 className="font-heading text-xl text-[#cfb53b]">6. Economia virtuale</h2>
              <p>Oro, polvere arcana, carte e altri oggetti virtuali <strong>non hanno valore monetario reale</strong>. Non possono essere convertiti in denaro. Gli acquisti (se disponibili) sono per contenuti virtuali e sono definitivi salvo diverse disposizioni di legge.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">7. Proprietà intellettuale</h2>
              <p>Il codice, la grafica, i testi originali del gioco e il marchio "Arcane Chronicles" sono di proprietà del gestore. I contenuti generati dall'IA durante la tua partita possono essere usati da te per uso personale e non commerciale. Il gestore conserva una licenza sui dati di gioco aggregati per finalità analitiche.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">8. Disponibilità del Servizio</h2>
              <p>Il Servizio può subire interruzioni per manutenzione, aggiornamenti o cause di forza maggiore. Non garantiamo disponibilità 24/7. Limiti giornalieri alle generazioni IA possono essere introdotti senza preavviso.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">9. Limitazione di responsabilità</h2>
              <p>Nel massimo consentito dalla legge, il Servizio è fornito "as-is", senza garanzie di alcun tipo. Il gestore non è responsabile per perdite indirette, perdita di dati di gioco dovute a malfunzionamenti di terze parti, o contenuti generati dall'IA.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">10. Sospensione e chiusura</h2>
              <p>Possiamo sospendere o chiudere il tuo account in caso di violazione di questi Termini o della Privacy Policy. I dati collegati possono essere cancellati dopo 30 giorni dalla chiusura.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">11. Legge applicabile</h2>
              <p>Questi Termini sono regolati dalla legge italiana. Per qualsiasi controversia, il foro competente è quello del domicilio del titolare, salvo diversa disposizione inderogabile di legge.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">12. Modifiche</h2>
              <p>Possiamo aggiornare questi Termini. Le modifiche sostanziali verranno comunicate con preavviso di almeno 15 giorni via email o avviso in-app.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">13. Contatti</h2>
              <p><a className="text-[#cfb53b]" href={`mailto:${EMAIL}`}>{EMAIL}</a></p>
            </>
          ) : (
            <>
              <h2 className="font-heading text-xl text-[#cfb53b] mt-4">1. Acceptance</h2>
              <p>By using Arcane Chronicles (the "Service") you fully accept these Terms of Service. If you disagree, stop using the Service.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">2. Description</h2>
              <p>Arcane Chronicles is a narrative role-playing game featuring AI-generated content (text, images), card battles, card collecting and player-to-player trading. The service is provided "as-is".</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">3. Account</h2>
              <ul className="list-disc pl-5">
                <li>You must be at least 13 (16 in EU) to register.</li>
                <li>You are responsible for your credentials' security.</li>
                <li>You may not transfer, sell or share your account.</li>
                <li>You can request deletion at any time by writing to <a className="text-[#cfb53b]" href={`mailto:${EMAIL}`}>{EMAIL}</a>.</li>
              </ul>

              <h2 className="font-heading text-xl text-[#cfb53b]">4. AI-Generated Content</h2>
              <p>AI-generated narrative and visual content is created dynamically based on your choices. It may contain errors, inconsistencies or unexpected outputs. We do not guarantee historical, scientific or moral accuracy. The Service is not liable for AI-generated content.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">5. Prohibited Conduct</h2>
              <ul className="list-disc pl-5">
                <li>Circumventing AI generation limits or anti-abuse mechanisms.</li>
                <li>Using unauthorized bots, scripts or automated means.</li>
                <li>Attempting to compromise system security.</li>
                <li>Inserting illegal, offensive, discriminatory content in prompts or names.</li>
                <li>Using the trading system to defraud other players.</li>
                <li>Selling cards, gold or accounts for real currency outside the Service.</li>
              </ul>

              <h2 className="font-heading text-xl text-[#cfb53b]">6. Virtual Economy</h2>
              <p>Gold, arcane dust, cards and other virtual items <strong>have no real monetary value</strong>. They cannot be converted to money. Purchases (if available) are for virtual content and are final except as required by law.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">7. Intellectual Property</h2>
              <p>Code, graphics, original game texts and the "Arcane Chronicles" brand are property of the operator. AI-generated content during your playthrough may be used by you for personal non-commercial use. The operator retains a license on aggregate game data for analytical purposes.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">8. Service Availability</h2>
              <p>The Service may experience interruptions for maintenance, updates or force majeure. We do not guarantee 24/7 availability. Daily AI generation limits may be introduced without notice.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">9. Limitation of Liability</h2>
              <p>To the maximum extent permitted by law, the Service is provided "as-is", without any warranties. The operator is not liable for indirect losses, loss of game data due to third-party malfunctions, or AI-generated content.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">10. Suspension and Termination</h2>
              <p>We may suspend or close your account if you violate these Terms or the Privacy Policy. Linked data may be deleted after 30 days from closure.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">11. Governing Law</h2>
              <p>These Terms are governed by Italian law. For any dispute, the competent court is that of the controller's domicile, unless differently mandated by law.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">12. Changes</h2>
              <p>We may update these Terms. Substantial changes will be notified with at least 15 days advance notice via email or in-app notice.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">13. Contact</h2>
              <p><a className="text-[#cfb53b]" href={`mailto:${EMAIL}`}>{EMAIL}</a></p>
            </>
          )}
        </>
      )}
    </StaticPageLayout>
  );
}
